export const MAIN_BACKGROUND_COLOR = "#faf7ff";
export const MAIN_ICON_COLOR = "#dcceff";